import {
    Homepage,
    Intro,
    Economisesc,
    CampaignMecanism,
    ArcticEnel,
    EnelRelax,
    // Problem - Solution Pages
    FridgeProblem,
    FrigdeSoltion,
    OvenProblem,
    OvenSolution,
    StoveProblem,
    StoveSolution,
    WashingProblem,
    WashingSolution,
    DishwasherProblem,
    DishwasherSolution
} from './components/pages';

export const Routes = [{
    name: 'Economiseste energie',
    path: '/economiseste-energie',
    component: Homepage,
    exclude: false,
    crt: 1
}, {
    name: 'Intro',
    path: '/intro',
    component: Intro,
    exclude: true
}, {
    name: 'Economisesc, dar cum?',
    path: '/economisesc-dar-cum',
    component: Economisesc,
    exclude: true
}, {
    name: 'Frigider',
    path: '/frigider-problema',
    component: FridgeProblem,
    exclude: false,
    crt: 2
}, {
    name: 'Frigider',
    path: '/frigider-solutie',
    component: FrigdeSoltion,
    exclude: true
}, {
    name: 'Cuptor',
    path: '/cuptor-problema',
    component: OvenProblem,
    exclude: false,
    crt: 3
}, {
    name: 'Cuptor',
    path: '/cuptor-solutie',
    component: OvenSolution,
    exclude: true,
}, {
    name: 'Plita electrica',
    path: '/plita-electrica-problema',
    component: StoveProblem,
    exclude: false,
    crt: 4
}, {
    name: 'Plita electrica',
    path: '/plita-electrica-solutie',
    component: StoveSolution,
    exclude: true,
}, {
    name: 'Masina de spalat rufe',
    path: '/masina-de-spalat-rufe-problema',
    component: WashingProblem,
    exclude: false,
    crt: 5
}, {
    name: 'Masina de spalat rufe',
    path: '/masina-de-spalat-rufe-solutie',
    component: WashingSolution,
    exclude: true
}, {
    name: 'Masina de spalat vase',
    path: '/masina-de-spalat-vase-problema',
    component: DishwasherProblem,
    exclude: false,
    crt: 6
}, {
    name: 'Masina de spalat vase',
    path: '/masina-de-spalat-vase-solutie',
    component: DishwasherSolution,
    exclude: true,
}, {
    name: 'Mecanism',
    path: '/mecanism-campanie',
    component: CampaignMecanism,
    exclude: false,
    crt: 7
}, {
    name: 'Oferta Enel',
    path: '/campanie-enel-relax',
    component: EnelRelax,
    exclude: false,
    crt: 8
}, {
    name: 'Arctic si Enel',
    path: '/campanie-arctic-enel',
    component: ArcticEnel,
    exclude: false,
    crt: 9
}

];


// WEBPACK FOOTER //
// ./src/Routes.js